var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.typesArray),function(type){return _c('b-badge',{key:type,staticClass:"mx-1 my-1",style:({
      backgroundColor: _vm.getTaskTypeColor(type),
    }),attrs:{"pill":""}},[_vm._v(" "+_vm._s(type))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }